export default "__VITE_ASSET__JO$PFXb0__"